import { Component, Input, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBooleanComponent } from '../../models/input-boolean';

const APP_TOGGLE_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => ToggleButtonComponent),
  multi: true
};

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  providers: [APP_TOGGLE_BUTTON_VALUE_ACCESSOR]
})
export class ToggleButtonComponent extends InputBooleanComponent {
  public static idCounter = 0;
  public id: string;
  @Input() label = 'Toggle';

  public constructor() {
    super();
    this.id = `${ToggleButtonComponent.idCounter++}`;
  }

  @HostListener('click')
  public onClick(): void {
    this.value = !this.value;
  }
}
